import { render, staticRenderFns } from "./FocusAreasReportPreview.vue?vue&type=template&id=12ef8ee4"
import script from "./FocusAreasReportPreview.vue?vue&type=script&lang=ts"
export * from "./FocusAreasReportPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports